import { render, staticRenderFns } from "./BetslipAreaC.vue?vue&type=template&id=a7c39b7e&scoped=true"
import script from "./BetslipAreaC.vue?vue&type=script&lang=js"
export * from "./BetslipAreaC.vue?vue&type=script&lang=js"
import style0 from "./BetslipAreaC.vue?vue&type=style&index=0&id=a7c39b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c39b7e",
  null
  
)

export default component.exports